export const REPORT_COLUMNS = [
    {
        field: 'reportType',
        headerName: 'Report Type',
        width: 350,
    },
    {
        field: 'address',
        headerName: 'Report Name',
        width: 350,
    },
    {
        field: 'sharedBy',
        headerName: 'Generated By',
        width: 350,
    },
    {
        field: 'createdAt',
        headerName: 'Date Created',
        width: 350,
    },
    {
        field: 'Actions',
        headerName: '',
        width: 350,
    },
];

export const RISK_REPORT_COLUMNS = [
    {
        field: 'name',
        headerName: 'Name',
        width: 350,
    },
    {
        field: 'address',
        headerName: 'Address',
        width: 350,
    },
    {
        field: 'riskFactors',
        // Deliberately not "Risk Factors" or "Coverage": chips only render
        // when the report surfaced something (Criminal Records needs records,
        // Sex Offenders Match needs a match), and not everything surfaced is
        // a risk (Low Crime Area, Area Crime Data). "Findings" is the one
        // word that is true of every chip.
        headerName: 'Findings',
        width: 350,
    },
    {
        field: 'sharedBy',
        headerName: 'Generated By',
        width: 350,
    },
    {
        field: 'createdAt',
        headerName: 'Date',
        width: 350,
    },
    {
        field: 'Actions',
        headerName: 'Actions',
        width: 350,
    },
];